import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import {LOCO_TYPE, REPAIR_SHOP_NAMES} from "../../../constants/Constants";
import {LOCO_HEADER_COLOR, REPAIR_STAGE_COLORS} from "../GameStyleUI";
import brigade_chips_icon from "../../../images/gameplay_ui/icons/brigade_chips_icon.svg";
import gear_icon from "../../../images/gameplay_ui/icons/gear_icon.svg";
import GameController from "../../../gameplay/controllers/GameController";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import GameData from "../../../gameplay/model/GameData";
import LocoPopupCard from "../LocoCards/LocoPopupCard";
import {RepairPlaces, RepairStagesCount} from "../../../gameplay/model/Balance";
import agent from "../../../agent";
import UtilsFunctions from "../../../utils/UtilsFunctions";


export default class RepairWindowUI extends React.Component {
    constructor() {
        super();

        this.trainsOnGround = GameData.CurrentGame.locosOnGround();
        let trainMasterIndex = UtilsFunctions.getRoleNameIndex("Заместитель по тяге");
        this.isTrainMaster = UtilsFunctions.playerHasRole(trainMasterIndex);
    }

    componentDidMount() {
        let data = this.props.repairShop;
        let shopID = GameData.CurrentGame.repairShops.findIndex(shop => shop.partsType === this.props.repairShop.partsType);

        let correctLocos = [];
        for (let locoID of data.stages[3]) {
            let loco = GameData.CurrentGame.getLocoById(locoID);

            if (loco.isReparing)
                correctLocos.push(locoID)
        }

        this.props.repairShop.stages[3] = correctLocos;
        GameData.CurrentGame.repairShops[shopID].stages[3] = correctLocos;
    }

    tryMoveToRepair(locoId, from, to) {
        if (!this.isTrainMaster) {
            alert("Ремонтировать локомотивы может только Заместитель по тяге");
            return;
        }

        let repairShop = this.props.repairShop;

        if (from < to && GameController.calculateRepairBrigadeChips(repairShop) === 0) {
            alert("У вас не хватает трудозатрат");
            return false;
        }
        if (from < to && GameController.calculateParts(repairShop) === 0) {
            alert("У вас не хватает запчастей");
            return false;
        }

        let loco = GameData.CurrentGame.getLocoById(locoId);
        let isCanMove = to < 0 || repairShop.stages[to].length < RepairPlaces[repairShop.partsType];
        if (isCanMove) {
            if (from >= 0 && from < RepairStagesCount) {
                repairShop.stages[from] = repairShop.stages[from].filter(x => x !== locoId);
                if (to < 0)
                    loco.isReparing = !loco.isReparing;
            }
            if (to >= 0 && to < RepairStagesCount) {
                repairShop.stages[to].push(locoId);
                loco.isReparing = !loco.isReparing;
            }
            agent.GamePlay.moveLocoToRepair(this.props.teamID, {
                locoId: locoId,
                stageFrom: from,
                stageTo: to,
                repairShopId: repairShop.id
            }, (response) => {
                console.log(response)
            })
        } else {
            alert("Нет свободного места");
        }
        this.forceUpdate();
        return isCanMove;
    }

    getLocoScroll(repairShop) {
        let scrollStyle = {
            overflowY: "visible",
            overflowX: "hidden",
            height: "666px",
            width: "116px",
            marginTop: "10px",
            marginLeft: "10px"
        }

        let cards = [];
        let locomotives = GameData.CurrentGame.locomotives.filter(loco =>
            this.trainsOnGround.indexOf(loco.id) === -1 &&
            loco.parentStation === repairShop.parentStationID &&
            loco.partsType === repairShop.partsType &&
            (loco.state < 10 || loco.isBreakDown) &&
            !repairShop.isLocoRepairing(loco));
        for (let i = 0; i < locomotives.length; i++) {
            let loco = locomotives[i];
            cards.push(<LocoPopupCard key={i} loco={loco} style={{paddingBottom: "10px"}} onClick={() => {
                this.tryMoveToRepair(loco.id, -1, loco.isBreakDown ? 0 : 1);
            }}
            />)
        }
        cards = <div style={scrollStyle}>{cards}</div>
        return <div>
            {cards}
        </div>
    }

    getRepairSteps(repairShop) {
        let repairColumns = repairShop.partsType === LOCO_TYPE ? 2 : 4;
        let columns = "110px";
        for (let i = 0; i < repairColumns - 1; i++) {
            columns += " 110px"
        }
        let mainStyle = {
            paddingTop: "10px",
            paddingRight: "10px",
            display: "grid",
            gridTemplateColumns: columns,
            gridTemplateRows: "159px 159px 159px 159px",
            gridRowGap: "10px",
            gridColumnGap: "10px"
        }
        let repairPlaceCardStyle = {
            borderRadius: "5px"
        }

        let stages = [];
        for (let i = 0; i < RepairStagesCount; i++) {
            let stage = repairShop.stages[i];
            for (let j = 0; j < repairColumns; j++) {
                let loco_card = null;
                if (stage.length > j) {
                    let loco = GameData.CurrentGame.getLocoById(stage[j]);
                    loco_card = <LocoPopupCard
                        loco={loco}
                        style={{margin: "5px"}}
                        onClick={() => {
                            let from = i;
                            let to = loco.isReparing ? (i === 1 && !loco.isBreakDown ? -1 : i - 1) : i + 1;
                            this.tryMoveToRepair(loco.id, from, to);
                        }}
                    />
                }
                stages.push(<div key={i + "" + j} style={{
                    ...repairPlaceCardStyle,
                    background: REPAIR_STAGE_COLORS[i]
                }}>
                    {loco_card}
                </div>)
            }
        }
        return <div style={mainStyle}>
            {stages}
        </div>;
    }

    render() {
        let repairShop = this.props.repairShop;
        let moveStyle = {
            position: "absolute",
            left: this.props.width / 2,
            top: this.props.height / 2,
            transform: window.innerWidth > 1500 ? "translate(-50%,-50%)" : "translate(-50%, -54%) scale(0.8)"
        }
        let width = repairShop.partsType === LOCO_TYPE ? 396 : 636;
        let colors = LOCO_HEADER_COLOR[repairShop.partsType];
        let currencyBlocks = [];
        currencyBlocks.push(<CurrencyCard
            key={'trud'}
            title={"Трудозатраты"}
            icon={brigade_chips_icon}
            value={GameController.calculateRepairBrigadeChips(repairShop)}
            size={20}
            fontSize={14}
            style={{
                marginLeft: "10px"
            }}/>);
        currencyBlocks.push(<CurrencyCard
            key={"parts"}
            title={"Запчасти"}
            icon={gear_icon}
            value={GameController.calculateParts(repairShop)}
            size={20}
            fontSize={14}
            style={{
                marginLeft: "10px"
            }}/>);

        let mainStyle = {
            display: "flex",
            justifyContent: "space-between"
        }
        let content = [];
        content.push(this.getLocoScroll(repairShop));
        content.push(this.getRepairSteps(repairShop));
        content = <div style={mainStyle}>{content}</div>
        return <div className="in-game-popup" style={{
            width: this.props.width,
            height: this.props.height,
            background: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)"
        }}>
            <div style={moveStyle}>
                <GameWindowHeader width={width} height={40} colorStart={colors[0]} colorEnd={colors[1]}
                                  onHide={this.props.onHide} title={`${REPAIR_SHOP_NAMES[repairShop.partsType]}`}
                                  isClosable={true} currencyBlocks={currencyBlocks}/>
                <GameWindowBg color={"#F2F2F2"} width={width} height={686} value={content}/>
            </div>

        </div>;
    }
}
